import { render, staticRenderFns } from "./SurveyPage.vue?vue&type=template&id=185c8170&scoped=true"
import script from "./SurveyPage.vue?vue&type=script&lang=js"
export * from "./SurveyPage.vue?vue&type=script&lang=js"
import style0 from "./SurveyPage.vue?vue&type=style&index=0&id=185c8170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c8170",
  null
  
)

export default component.exports